export const adminMenu = [
  {
    label: 'langkey.overview',
    to: 'admin-overview',
  },
  {
    label: 'langkey.orders',
    to: 'admin-orders',
  },
  {
    label: 'langkey.dealer-calculation',
    to: 'admin-dealer-calculation',
  },
  {
    label: 'langkey.offer-tool-settings',
    to: 'admin-offer-tool-settings',
  },
  {
    label: 'langkey.account-info',
    to: 'admin-account-info',
  },
  {
    label: 'langkey.general-terms-of-payment-and-delivery',
    to: 'admin-general-terms-of-payment-and-delivery',
  },
];
